import React from 'react'
import Page from '../Page/Page.js'
import PageContent from '../Page/PageContent'
import StompunktToolbarContainer from './StompunktToolbarContainer'
import StompunktSuccess from './StompunktSuccess'
import StompunktLoading from './StompunktLoading'
import StompunktErrorContainer from './StompunktErrorContainer'
import StompunktMissing from './StompunktMissing'
import PermalinkContainer from './PermalinkContainer'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import { prettyIdFromId, mbPlan } from '../../selectors/stompunkt'
import { mbHojd } from '../../selectors/stompunkt'
import { useMatomo } from '@datapunt/matomo-tracker-react'

const styles = {
	header: {
		flexShrink: 0, //IE11 flexbox bug fix
	}
}

const StompunktPage = ({ stompunkt, srid, showPermalink, classes }) => {
	return (
		<Page>
			<Toolbar showPermalink={showPermalink} />
			<PageContent padding>
				<Typography variant="headline" className={classes.header} gutterBottom>
					{prettyIdFromId(stompunkt.id)}
				</Typography>
				<StompunktBody stompunkt={stompunkt} srid={srid} />
			</PageContent>
	   </Page>
	)
}

export default withStyles(styles)(StompunktPage)

const Toolbar = ({ showPermalink }) => {
	return showPermalink
		? <PermalinkContainer />
		: <StompunktToolbarContainer />
}


const StompunktBody = ({ stompunkt, srid }) => {
	const { trackEvent } = useMatomo()
	switch (stompunkt.status) {
		case 'SUCCESS':
			if (stompunkt.data) {
				trackEvent({ category: 'Visa', action: 'Stompunkt',name: getTrackingName(stompunkt.data)})
			}		
			return <StompunktSuccess stompunkt={stompunkt.data} srid={srid} />
		case 'ERROR':
			return <StompunktErrorContainer id={stompunkt.id} />
		case 'LOADING':
			return <StompunktLoading />
		case 'MISSING':
			return <StompunktMissing />
		default:
			return null
	}

	function getTrackingName(stompunkt) {
		return stompunkt.properties.typ + 
		'Kvalitetsklass: ' + 
		((stompunkt.properties.typ.toUpperCase() === 'PLANPUNKT') ? mbPlan(stompunkt).kvalitetKlass : (stompunkt.properties.typ.toUpperCase() === 'HÖJDPUNKT') ? mbHojd(stompunkt).kvalitetKlass : '')
	}
}



// WEBPACK FOOTER //
// ./src/components/Stompunkt/StompunktPage.js